import React, { useContext } from 'react';
import { createPortal } from 'react-dom';
import { navigate } from '@reach/router';
import $ from 'jquery';
import { PageContext } from '../../context/PageContext';

import HiddenForm from '../HiddenForm';

import { getDraftUrl, getEditDraftUrl } from '../../utilities/urlHelper';

export default (props) => {
    const { page } = useContext(PageContext);
    const { existing_draft_id, existing_draft_is_suggest_edit } = page || {};

    if (!existing_draft_id || existing_draft_is_suggest_edit) return null;

    const editDraftUrl = getEditDraftUrl(existing_draft_id);

    const onClick = (e) => {
        if (!window.loggedIn || !window.userId || e.metaKey || e.ctrlKey) return;
        e.preventDefault();

        return navigate(editDraftUrl);
    };

    return (
        <div className="info-message">
            <div className="message-text">
                You have unpublished changes for this page
            </div>
            <button className="message-btn sm-show" href={editDraftUrl} onClick={onClick} type="button">Continue Editing</button>
            <HiddenForm style="message-btn sm-show" color="red" value="Discard changes" method="delete" url={getDraftUrl(existing_draft_id)} />
        </div>
    );
};
